import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'PlacePrep',
        projectDesc: ' A student placement mobile app with personalized coding dashboards.Incorporated contest reminders, note-taking, and a soft skill section within PlacePrep, enriching students’ preparation.',
        tags: ['React Native', 'Express JS', 'MongoDB'],
        code: 'https://github.com/Navi-2004/StudentConnect',
        demo: 'https://github.com/Navi-2004/StudentConnect',
        image: one
    },
    {
        id: 2,
        projectName: 'AeroBook',
        projectDesc: 'Engineered a PERN flight booking system.Integrated Stripe payment and admin features.Implemented QR code for accessing ticket information and integrated weather forecasting ',
        tags: ['React', 'Express JS', 'PostgreSQL', 'Stripe'],
        code: 'https://github.com/Navi-2004/FlightTask',
        demo: 'https://github.com/Navi-2004/FlightTask',
        image: two
    },
    {
        id: 3,
        projectName: 'PlacesHub',
        projectDesc: 'Streamlined connectivity between hosts and guests for frictionless interactions in a rental platform.',
        tags: ['ReactJs', 'MongoDB', 'Node'],
        code: 'https://github.com/Navi-2004/PlacesHub',
        demo: 'https://github.com/Navi-2004/PlacesHub',
        image: three
    },
    {
        id: 4,
        projectName: 'Library Management System',
        projectDesc: 'A simple library management system with noval features of marking the books as read and unread.',
        tags: ['React', 'Node JS', 'SQL'],
        code: 'https://github.com/Navi-2004/LibraryManagement',
        demo: 'https://github.com/Navi-2004/LibraryManagement',
        image: four
    },
    {
        id: 5,
        projectName: 'Netflix Clone',
        projectDesc: 'Netflix clone with MERN stack. User authentication and movie trailers.',
        tags: ['React ','MongoDB','Node JS','Firebase'],
        code: 'https://github.com/Navi-2004/Netflix-Clone',
        demo: 'https://github.com/Navi-2004/Netflix-Clone',
        image: five
    },
    {
        id: 6,
        projectName: '30 Before 30 Blog',
        projectDesc: 'A blog website with a simple UI and a backend to manage the posts.',
        tags: ['React'],
        code: 'https://github.com/Navi-2004/3o-Before-30',
        demo: 'https://github.com/Navi-2004/3o-Before-30',
        image: six
    },
    {
        id: 7,
        projectName: 'Employee Management System',
        projectDesc: 'A simple employee management system with features of adding, deleting, and updating the employee details.',
        tags: ['React', 'Redux', 'Bootstrap', 'Node JS', 'SQL'],
        code: 'https://github.com/Navi-2004/EmployeeSQL',
        demo: 'https://github.com/Navi-2004/EmployeeSQL',
        image: seven
    },
    {
        id: 8,
        projectName: 'Modern React Website',
        projectDesc: 'A modern website built with React and Tailwind CSS.',
        tags: ['Tailwind CSS', 'React'],
        code: 'https://github.com/Navi-2004/Modern-React',
        demo: 'https://github.com/Navi-2004/Modern-React',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/